/**
 * `core/wordpress/mwwpform/recaptcha.js`
 * - Google reCAPTCHA の処理
 *
 * 使用方法:
 * - import {initReCAPTCHA, loadReCaptcha} from "../mwwpform/index.js";
 */


import {config} from "../../../config.js";
import {barbaEventObserver} from "../../barba/utils/barbaEventObserver.js";


/**
 * initReCAPTCHA
 * - Google reCAPTCHAの初期化
 * - デフォルトの仕様: 2分制限 の解除
 */
export function initReCAPTCHA() {
  console.log("🔑 Initializing reCAPTCHA (Optimized for SPA)...");

  const mwWpFormSubmit = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]');
  if (!mwWpFormSubmit) return;

  mwWpFormSubmit.addEventListener('click', sendReCAPTCHA);  // 送信ボタンクリック時にトークン取得処理を開始
  barbaEventObserver.observeEvents([[mwWpFormSubmit, 'click', sendReCAPTCHA]]);
}


/**
 * sendReCAPTCHA
 * - reCAPTCHA の送信処理
 * - initReCAPTCHAで実行
 * - 3分制限を回避するため、送信直前にトークンを取得
 * - AJAX検証は行わず、プラグインが検証するためのフィールドにトークンを渡す
 */
function sendReCAPTCHA(e) {
  e.preventDefault();

  const submitBtn = e.currentTarget;
  const form = document.querySelector('.mw_wp_form > form');

  // 二重送信防止
  submitBtn.disabled = true;

  grecaptcha.ready(() => {  // eslint-disable-line no-undef
    grecaptcha.execute(config.recaptchaPublicKey, {action: "submit"}).then((token) => { // eslint-disable-line no-undef

      // 1. プラグインが用意している隠しフィールドにトークンをセット
      let recaptchaField = form.querySelector('input[name="recaptcha-v3"]');
      if (!recaptchaField) {
        recaptchaField = document.createElement("input");
        recaptchaField.type = "hidden";
        recaptchaField.name = "recaptcha-v3"; // MW WP Form reCAPTCHAプラグインの標準的な名前
        form.appendChild(recaptchaField);
      }
      recaptchaField.value = token; // 新鮮なトークンをセット

      // 2. MW WP Form が「確認画面へ」ボタンが押されたと認識させるためのダミー
      if (!form.querySelector('input[type="hidden"][name="submitConfirm"]')) {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = "submitConfirm";
        hiddenField.value = "確認画面へ";
        form.appendChild(hiddenField);
      }

      // 3. 送信（プラグイン側がサーバー側で 1回だけ検証する）
      form.submit();
    });
  });
}


/**
 * loadReCaptcha
 * Google reCAPTCHAスクリプトの動的読み込み
 **/
export function loadReCaptcha() {
  const siteKey = config.recaptchaPublicKey;
  if (document.getElementById("recaptcha-script-js")) return;

  const script = document.createElement("script");
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  script.id = "recaptcha-script-js";
  document.body.appendChild(script);
}